/**
 * Check if we should show debug logs
 * Returns true for:
 * - Development environment (localhost)
 * - Staging environment (for testing with James)
 */
export function shouldShowDebugLogs(): boolean {
  // Always show in development
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  
  // Also show on staging for debugging
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname === 'staging.abbeydentalsupplies.com';
  }
  
  return false;
}
